var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDiscountTf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6666 7.16669C14.9399 7.16669 15.1666 6.94002 15.1666 6.66669V6.00002C15.1666 3.06002 14.2733 2.16669 11.3333 2.16669H7.16659V3.66669C7.16659 3.94002 6.93992 4.16669 6.66659 4.16669C6.39325 4.16669 6.16659 3.94002 6.16659 3.66669V2.16669H4.66659C1.72659 2.16669 0.833252 3.06002 0.833252 6.00002V6.33335C0.833252 6.60669 1.05992 6.83335 1.33325 6.83335C1.97325 6.83335 2.49992 7.36002 2.49992 8.00002C2.49992 8.64002 1.97325 9.16669 1.33325 9.16669C1.05992 9.16669 0.833252 9.39335 0.833252 9.66669V10C0.833252 12.94 1.72659 13.8334 4.66659 13.8334H6.16659V12.3334C6.16659 12.06 6.39325 11.8334 6.66659 11.8334C6.93992 11.8334 7.16659 12.06 7.16659 12.3334V13.8334H11.3333C14.2733 13.8334 15.1666 12.94 15.1666 10C15.1666 9.72669 14.9399 9.50002 14.6666 9.50002C14.0266 9.50002 13.4999 8.97335 13.4999 8.33335C13.4999 7.69335 14.0266 7.16669 14.6666 7.16669ZM7.16659 9.44669C7.16659 9.72002 6.93992 9.94669 6.66659 9.94669C6.39325 9.94669 6.16659 9.72002 6.16659 9.44669V6.55335C6.16659 6.28002 6.39325 6.05335 6.66659 6.05335C6.93992 6.05335 7.16659 6.28002 7.16659 6.55335V9.44669Z",
    fill: "#808985"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDiscountTf);
export default __webpack_public_path__ + "static/media/Icon_discountTF.2e048956c5218a4315f1fa4241e34d76.svg";
export { ForwardRef as ReactComponent };